import './signer.scss'

import { PropType } from "vue"
import Component from "vue-class-component"

import { Signer as SignerType, SkinDate, createTranslatedString, getTranslatedString } from "@skinsoft/types"
import { DATE_FORMATS, buildSkinDateWithFormat, toFormat } from "@skinsoft/utils"

import { ReactiveVue } from "@skinsoft/reactive-vue"
import ThesaurusTermTree from "@skinsoft/ui/src/thesaurus-term-tree"
import { TextField, FIELD_VALUE_UPDATED } from "@skinsoft/ui2"
import { SIGNER_UPDATED } from "../../../../../busTopics"
import { THESAURUS_TERM_SELECTED } from '@skinsoft/ui/src/thesaurus-term-tree/thesaurus-term-tree-modal'

@Component({
    components: {
        sTextField: TextField,
        sThesaurusTermTree: ThesaurusTermTree,
    },
    props: {
        type: Array,
        form: {},
        fieldName: {},
        signer: {
            type: Object as PropType<SignerType>,
        },
        canBeDeleted: {
            type: Boolean,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        showTitle: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: 'editReportScreen.reportContext.reportDoneInThePresenceOf'
        },
        showDate: {
            type: Boolean,
            default: false,
        },
    },
    template: require("./signer.html")
})
export class Signer extends ReactiveVue {
    private signer: SignerType
    private readOnly: Boolean
    private showDate: Boolean
    private canBeDeleted: Boolean

    private THESAURUS_TERM_SELECTED = THESAURUS_TERM_SELECTED
    private FIELD_VALUE_UPDATED = FIELD_VALUE_UPDATED

    private getSignerName() {
        return getTranslatedString(this.signer.signer, this.$i18n.locale)
    }

    private onNameUpdated(name) {
        let updatedSigner: SignerType = {...this.signer}
        if(updatedSigner.signer?.translatedString) {
            updatedSigner.signer.translatedString[this.$i18n.locale] = name
        } else {
            updatedSigner.signer = createTranslatedString(this.$i18n.locale, name)
        }
        this.updateSigner(updatedSigner)
    }

    private getPositionId() {
        return (this.signer.positionOfSignatory as any)?.ref ?? this.signer.positionOfSignatory
    }

    private onPositionUpdated(thesaurusTermId: string) {
        let updatedSigner: SignerType = {...this.signer}
        updatedSigner.positionOfSignatory = thesaurusTermId
        this.updateSigner(updatedSigner)
    }

    public get dateValue(): string {
        if(this.signer.dateOfSignature) {
            return toFormat(this.signer.dateOfSignature as SkinDate, DATE_FORMATS.YYYY_MM_DD_DASH)
        }
        return ""
    }

    public set dateValue(value: string) {
        if(value) {
            let updatedSigner: SignerType = {...this.signer}
            updatedSigner.dateOfSignature = buildSkinDateWithFormat(value, DATE_FORMATS.YYYY_MM_DD_DASH)
            this.updateSigner(updatedSigner)
        }
    }

    private updateSigner(updatedSigner: SignerType) {
        this.$emit(
            SIGNER_UPDATED, 
            updatedSigner
        )
    }

    private getDateFormatOptions() {
        return {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        }
    }
}